import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Game from './pages/VirtualHotelGame';

// Firebase imports
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/analytics'; // Use analytics instead of database
import LandingPage from './pages/LandingPage';
import About from './pages/About';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import BlogsPage from './pages/BlogsPage';
import BlogDetailPage from './pages/Blog';
import ContactPage from './pages/Contact';
import PlayLandingPage from './pages/PlayLandingPage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const auth = firebase.auth();
const analytics = firebase.analytics();

// Simple authentication check
const isAuthenticated = () => {
  return localStorage.getItem('token') !== null;
};

// Protected route component
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  useEffect(() => {
    // Log user presence when the app loads
    analytics.logEvent('user_presence', {
      timestamp: new Date().toISOString(),
      page: window.location.pathname
    });

    // Set up page tracking for analytics
    const trackPageView = () => {
      const page_path = window.location.pathname;
      analytics.logEvent('page_view', { page_path });
      analytics.logEvent('user_presence', { 
        timestamp: new Date().toISOString(),
        page: page_path
      });
    };

    // Track initial page view
    trackPageView();

    // Track page changes
    const handleRouteChange = () => {
      trackPageView();
    };

    // Add listener for route changes
    window.addEventListener('popstate', handleRouteChange);

    // Remove listener on cleanup
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  return (
    <Router>
      <Routes>
      <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/play" element={<PlayLandingPage />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/game"
          element={
            <ProtectedRoute>
              <Game />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

// Export Firebase services for use in other components
export { auth, analytics, firebase };
export default App;